import { render } from "./ThePhanLoaiTruong.vue?vue&type=template&id=16946cc0"
import script from "./ThePhanLoaiTruong.vue?vue&type=script&lang=js"
export * from "./ThePhanLoaiTruong.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__